import {UNDO, UPDATE_METADATA} from "./types";

export const updateMetadataAction = (siteName, prop, value) => ({ type: UPDATE_METADATA, payload: {siteName, prop, value} });

export const undoAction = (siteName, settings) => ({ type: UNDO, payload: {siteName, settings} });